import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Profile } from './master-bo-consulta-perfil.models';
const BASE_PATH = environment.basePath;
@Injectable({
  providedIn: 'root'
})
export class MasterConsultaProfileService {

  constructor(
    private _$http: HttpClient
  ) { }

  getProfiles(active) {

    const payload = {"active": active};

    return this
            ._$http
            .post<any>(`${BASE_PATH}/bff/master/clients/profiles/list`, payload)
            .toPromise()
  }


  getProfileSearch(name) {

    const payload = {"name": name};

    return this
        ._$http
        .post<any>(`${BASE_PATH}/bff/master/clients/profiles/list`, payload)
        .toPromise()
  }
}
